export default __webpack_public_path__ + "static/media/logonews.876e7e84.png";